import React,{useState} from 'react';
import * as S from './RnRTabContent.styles';
import RnRUserReviewBlock from '../RnRUserReviewBlock/RnRUserReviewBlock';
import RnRRatingRange from '../RnRRatingRange/RnRRatingRange';
import {ratingColorConfig} from './../../../../../containers/Common/config'
import {RATING_REVIEW_SHOW_COUNT} from './../../../../../containers/Common/Constants'
import ContentUnavailable from './../../SrpErrorStates/ContentUnavailable';
import {SEAT_LAYOUT} from './../../../../../config/messages';
import Loader from './../../SrpLoader/Loader/Loader';
const RnRTabContent = (props) => {
  
  const{data,bid,onShowAllReview,isLoading,error} = props;
  
  if(error){
  return <S.RnRTabContent>
    <ContentUnavailable text={SEAT_LAYOUT.RATING_REVIEW_ERROR}></ContentUnavailable>
  </S.RnRTabContent>
  }
  if(isLoading){
    return <S.RnRTabContent>
      <Loader></Loader>
  </S.RnRTabContent>
  }
  if(!data.reviews || !data.reviews.total_reviews){
    return <S.RnRTabContent>
      <ContentUnavailable text={SEAT_LAYOUT.RATING_REVIEW_NOT_AVAILABLE}></ContentUnavailable>
    </S.RnRTabContent>
    }
    const tags = data.reviews.Tags
    const ratings = data.reviews.ratings;
    const totalReviewsCount = data.reviews.total_reviews;
    const totalRatingCount = ratings.totalRatings;
    const overallRating = ratings.averageRating;
    const ratingInfo = function(){
      let data={}
      for(let i in ratings.ratings_percentage){
        data[i] ={percentage:ratings.ratings_percentage[i],count:0}
      }
   return data;

    }();
   const all = data.reviews.tag_reviews;
  const {likedView,dislikedView} = getLiked_DislikedView(tags,bid);
  const [showAllReview,toggleReviewView] = useState(false);
  const userReviewView = getUserReviewView(all,bid,RATING_REVIEW_SHOW_COUNT,showAllReview);

  return (
  <S.RnRTabContent>
    <S.RatingSummary>
      <RnRRatingRange ratingInfo={ratingInfo} overallRating={overallRating} totalReviewsCount={totalReviewsCount} totalRatingCount={totalRatingCount}/>
      <S.UserReviewSummary>
        <p>People Liked</p>
        <S.ReviewTabsWrap>
          {likedView}
        </S.ReviewTabsWrap>
      </S.UserReviewSummary>

    <S.UserReviewSummary>
        <p>Could Be Better</p>
        <S.ReviewTabsWrap>
          {dislikedView}
        </S.ReviewTabsWrap>
      </S.UserReviewSummary>
    </S.RatingSummary>
    <S.ReviewWrap>
      {userReviewView}
    </S.ReviewWrap>
    <S.PopupButton onClick={onShowAllReview}>{`SEE ALL REVIEWS (${totalReviewsCount})`}</S.PopupButton>
  </S.RnRTabContent>
);
}
export default RnRTabContent;
function getLiked_DislikedView(data,bid){
  let likedView=[],dislikedView=[];
  for(let i in data){
    if(data.hasOwnProperty(i)){
      if(data[i].SentimentTypeId == 1){
        likedView.push(
          <S.ReviewTab key={bid+i+data[i].tagId} primary>
          <span>{data[i].tagmsg}</span>
        <S.NumberOfReview primary>{data[i].NoOfUsers}</S.NumberOfReview>
        </S.ReviewTab>
        
        )
      }else{
        dislikedView.push(
          <S.ReviewTab key={bid+i + data[i].tagId} secondary>
          <span>{data[i].tagmsg}</span>
        <S.NumberOfReview secondary>{data[i].NoOfUsers}</S.NumberOfReview>
        </S.ReviewTab>
        
        )
      }
     
    }
  }
 
return {likedView,dislikedView};
}
function getLikedView(data,bid){
  
  let view =[];
  for(let i in data){
    if(data.hasOwnProperty(i)){
      view.push(
        <S.ReviewTab key={bid+i} primary>
        <span>{i}</span>
      <S.NumberOfReview primary>{data[i]}</S.NumberOfReview>
      </S.ReviewTab>
      
      )
    }
  }
 
  return view;
}
function getDislikedView(data,bid){
  
  let view =[];
  for(let i in data){
    if(data.hasOwnProperty(i)){
      view.push(
        <S.ReviewTab key={bid+i} secondary>
        <span>{i}</span>
      <S.NumberOfReview secondary>{data[i]}</S.NumberOfReview>
      </S.ReviewTab>
      
      )
    }
  }
 
  return view;
}
function getUserReviewView(data,bid,reviewShowCount,showAllReview){
  var view =[];
//   ThumbsDown: 0
// ThumbsUp: 0
// departureDate: "20-12-2019"
// firstName: "anil"
// lastName: "agrawal"
// operatorReply: "We always try to provide the best service for our customer. Do give us another chance as we work to implement your feedback. "
// operatorReplyDate: "24-12-2019"
// reviewContent: "Drinking water."
// tagData: {Negative: Array(0), Positive: Array(0)}
// totalRating: "4.0"
  for(let i in data){
    if(data.hasOwnProperty(i)){
      if(showAllReview || reviewShowCount > view.length){
      const {lastName,totalRating,firstName,reviewContent,departureDate,liked,operatorReply,operatorReplyDate} = data[i];
      const departureDateArr =  departureDate.split("-")
      const date = departureDateArr[0];
      const month = departureDateArr[1];
      const year = departureDateArr[2];
    view.push(
    <S.RnRUserReviewBlockWrap key={bid+firstName+departureDate}>
    <RnRUserReviewBlock
      ratingcolor={ratingColorConfig[Math.round(totalRating)]}
      ratingcount={totalRating}
      username={`${firstName} ${lastName}`}
      reviewdate={`${date}-${month}-${year}`}
      reviewcontent={reviewContent}
      liked={liked}
      operatorReply={operatorReply}
      operatorReplyDate={operatorReplyDate}
    />
  </S.RnRUserReviewBlockWrap>
    )
      }
      if(!showAllReview && reviewShowCount === view.length){
        break;
      }
    }
}
return view;
}
